import React from 'react';
import './ShieldOverlay.css';

/**
 * ShieldOverlay Component
 * SVG animated shield overlay for units with Psionic Shield passive effect
 * Shows a semi-transparent dome/shield covering the unit
 */
function ShieldOverlay() {
  return (
    <div className="shield-overlay">
      <svg
        className="shield-svg"
        viewBox="0 0 100 100"
        preserveAspectRatio="none"
      >
        <defs>
          {/* Shield gradient - purple theme */}
          <linearGradient id="shieldGradient" x1="50%" y1="0%" x2="50%" y2="100%">
            <stop offset="0%" stopColor="#8B5CF6" stopOpacity="0.6" />
            <stop offset="100%" stopColor="#8B5CF6" stopOpacity="0.2" />
          </linearGradient>

          {/* Glow filter */}
          <filter id="shieldGlow" x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur stdDeviation="2" result="coloredBlur" />
            <feMerge>
              <feMergeNode in="coloredBlur" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
        </defs>

        {/* Shield dome shape - hexagonal top with rounded bottom */}
        <path
          className="shield-dome"
          d="M 50 5
             L 85 20
             L 90 50
             L 85 80
             Q 50 100 15 80
             L 10 50
             L 15 20
             Z"
          fill="url(#shieldGradient)"
          stroke="#8B5CF6"
          strokeWidth="2"
          filter="url(#shieldGlow)"
        />

        {/* Inner highlight arc */}
        <path
          className="shield-highlight"
          d="M 30 25 Q 50 15 70 25"
          fill="none"
          stroke="#FFFFFF"
          strokeWidth="2"
          strokeOpacity="0.5"
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
}

export default ShieldOverlay;
